import { regexEscape } from 'Helpers/regexHelpers'
import partial from 'Helpers/partial'
import pipe from 'Helpers/pipe'

export const replaceContentForPreview = (
  src,
  idList,
  domain,
  mandatorySenderInfo,
  sendingDate
) => {
  const replaceTemplateImageWithDomain = partial(
    replaceTemplateImagePath,
    domain
  )
  const replaceMandatorySenderMergeTagsWithInfo = partial(
    replaceMandatorySenderMergeTags,
    mandatorySenderInfo
  )
  const replaceSendingDateTagsWithDate = partial(
    replaceSendingDateTags,
    sendingDate
  )
  const replaceIdListTagWithIdList = partial(replaceIdListTag, idList)
  const replaceConsoleUrlWithDomain = partial(replaceConsoleUrl, domain)
  const replaceSendToAFriendTagWithDomain = partial(
    replaceSendToAFriendTag,
    domain
  )

  return pipe(
    replaceTemplateImageWithDomain,
    replaceStaticnlTag,
    replaceSubscribelinkTag,
    replaceUnsubscribeTag,
    replaceMandatorySenderMergeTagsWithInfo,
    replaceSendingDateTagsWithDate,
    replaceAutoprofileTags,
    replaceIdListTagWithIdList,
    replaceTrackTag,
    replaceConsoleUrlWithDomain,
    replaceSendToAFriendTagWithDomain,
    replaceAutoprofileTagWithId,
    disableSpecialUrlsClick
  )(src)
}

export const replaceTemplateImagePath = (domain, src) => {
  return src.replace(
    /src="\/(template\/images\/[^"]+)"/gi,
    `src="//${domain}/$1"`
  )
}

export const replaceStaticnlTag = src => {
  return src.replace(
    /(http:\/\/\[staticnl]\/)|(http:\/\/%5bstaticnl%5d\/)/gi,
    '[staticnl]'
  )
}

export const replaceSubscribelinkTag = src => {
  return src.replace(
    /(http:\/\/\[subscribelink]\/)|(http:\/\/%5bsubscribelink%5d\/)/gi,
    '[subscribelink]'
  )
}

export const replaceUnsubscribeTag = src => {
  return src
    .replace(
      /(http:\/\/\[unsubscribe]\/)|(http:\/\/%5bunsubscribe%5d\/)/gi,
      '[optout]'
    )
    .replace(/\[unsubscribe](?:\?idList=(\d+))?/gi, '[optout]')
}

export const replaceMandatorySenderMergeTags = (mandatorySenderInfo, src) => {
  return src
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_company]')),
      mandatorySenderInfo.CompanyName || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_contact]')),
      mandatorySenderInfo.ContactName || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_address]')),
      mandatorySenderInfo.Address || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_city]')),
      mandatorySenderInfo.City || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_state]')),
      mandatorySenderInfo.StateOrProvince || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_postalcode]')),
      mandatorySenderInfo.PostalCode || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_country]')),
      mandatorySenderInfo.Country || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_phone]')),
      mandatorySenderInfo.Phone || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_website]')),
      mandatorySenderInfo.WebSiteUrl || ''
    )
    .replace(
      new RegExp(regexEscape('[_mandatory_sender_info_permission_reminder]')),
      mandatorySenderInfo.PermissionReminder || ''
    )
}

export const replaceSendingDateTags = (extDate, src) => {
  return src
    .replace(new RegExp(regexEscape('[_currentday]')), extDate.Day.toString())
    .replace(new RegExp(regexEscape('[_currentdayname]')), extDate.DayName)
    .replace(
      new RegExp(regexEscape('[_currentmonth]')),
      extDate.Month.toString()
    )
    .replace(
      new RegExp(regexEscape('[_currentmonthname]')),
      extDate.MonthName.toString()
    )
    .replace(new RegExp(regexEscape('[_currentyear]')), extDate.Year.toString())
}

export const replaceAutoprofileTags = src => {
  return src.replace(
    /(http:\/\/\[autoprofile]\/)|(http:\/\/%5bautoprofile%5d\/)/gi,
    '[autoprofile]'
  )
}

export const replaceIdListTag = (idList, src) => {
  return src.replace(new RegExp(regexEscape('[_idlist]')), idList)
}

export const replaceSymbols = src => {
  return src
    .replace(new RegExp(regexEscape(':rQS*:amp;'), 'g'), '&')
    .replace(new RegExp(regexEscape(':rQS*:'), 'g'), '&')
    .replace(new RegExp(regexEscape(':rQS$:'), 'g'), '?')
    .replace(new RegExp(regexEscape('%23'), 'g'), '#')
}

export const replaceTrackTag = src => {
  return src.replace(
    /href="(?:http:\/\/\[track]\/)?([^"]*)"/g,
    (match, url) => `href="${replaceSymbols(url)}"`
  )
}

export const replaceConsoleUrl = (domain, src) => {
  return src
    .replace(/href="http:\/\/"/gi, 'href="#"')
    .replace(
      new RegExp(`href="http(s?)://${regexEscape(domain)}(/?)"`, 'gi'),
      'href="#"'
    )
    .replace(
      new RegExp(`href="http(s?)://${regexEscape(domain)}/console/"`, 'gi'),
      'href="#"'
    )
}

export const replaceSendToAFriendTag = (domain, src) => {
  return src
    .replace(
      new RegExp(
        `http(s?)://${regexEscape(domain)}/${regexEscape(
          'frontend/sendtoafriend.aspx?idNL=[_idnl]&amp;idoptin=[_idoptin]&amp;strHash=[_hash]'
        )}`,
        'gi'
      ),
      '[sendtoafriend]'
    )
    .replace(
      new RegExp(
        `http(s?)://${regexEscape(domain)}/${regexEscape(
          'frontend/sendtoafriend.aspx?idNL=[_idnl]&idoptin=[_idoptin]&strHash=[_hash]'
        )}`,
        'gi'
      ),
      '[sendtoafriend]'
    )
}

export const replaceAutoprofileTagWithId = src => {
  return src.replace(
    /href="\[autoprofile]&(?:amp;)?idForm=(\d+)"/gi,
    'href="[autoprofile:$1]"'
  )
}

export const disableSpecialUrlsClick = src => {
  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(src, 'text/html')

    const nodes = doc.querySelectorAll('[href^="#"],[href^="["]')

    nodes.forEach(n => {
      n.classList.add('in-preview-is-disable')
      n.setAttribute('onclick', 'return false')

      const style = (n.getAttribute('style') || '')
        .split(';')
        .concat('pointer-events: none')
        .filter(o => !!o)
        .join(';')

      n.setAttribute('style', style)
    })

    return doc.documentElement.outerHTML
  } catch (e) {
    return src.replace(
      /href="(#|\[[^]+])"/gi,
      'href="$1" class="in-preview-is-disable" style="pointer-events: none" onclick="return false"'
    )
  }
}
